/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown>, when: NonNullable<unknown> }} Recovery_Rest_NextInputs */

const en_us2_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next: ${i?.session} · ${i?.when}`)
};

const pt_br2_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo: ${i?.session} · ${i?.when}`)
};

const es_419_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo: ${i?.session} · ${i?.when}`)
};

const pt_pt2_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo: ${i?.session} · ${i?.when}`)
};

const fr_fr2_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochaine : ${i?.session} · ${i?.when}`)
};

const de_de2_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Als Nächstes: ${i?.session} · ${i?.when}`)
};

const it_it2_recovery_rest_next = /** @type {(inputs: Recovery_Rest_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossimo: ${i?.session} · ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Next: {session} · {when}" |
*
* @param {Recovery_Rest_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_rest_next = /** @type {((inputs: Recovery_Rest_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Rest_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_rest_next(inputs)
	if (locale === "es-419") return es_419_recovery_rest_next(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_rest_next(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_rest_next(inputs)
	if (locale === "de-DE") return de_de2_recovery_rest_next(inputs)
	if (locale === "it-IT") return it_it2_recovery_rest_next(inputs)
	return en_us2_recovery_rest_next(inputs)
});
export { recovery_rest_next as "recovery.rest_next" }